import { IPropertyAddress } from './IPropertyAddress';
import { hasEmail, IHasEmail } from '../../../types/shared/IHasEmail';
import { hasId, IHasId } from '../../../types/shared/IHasId';

export interface IPartySignatory {
  id?: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  email?: string;
  phoneNumber?: string;
  partySequence?: number;
  address?: IPropertyAddress;
}

export interface IPartySignatoryData {
  id?: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  email?: string;
  phoneNumber?: string;
  partySequence?: number;
  address?: IPropertyAddress;
}

export interface IPartySignatoryDataWithIdAndEmail
  extends Omit<IPartySignatoryData, 'email' | 'id'>,
    IHasEmail,
    IHasId {}

export const isSignatoryWithIdAndEmail = (
  signatory: IPartySignatory
): signatory is IPartySignatoryDataWithIdAndEmail => {
  return hasEmail(signatory) && hasId(signatory);
};
